import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';
// import { Storage } from '@ionic/storage';


export class MenuItem { 
    id: number;
    title: string;
    prices: number;
    minprice: number;
    note: string;
    image: string;
    veg: string;
    non_veg: string;
    packaging_cost;
    item = []
    Addon = []
    resturantId: string;
    tableID: string;
    floor: string;

    constructor(id: number, title: string, prices: number, minprice: number, note: string, veg: string, non_veg: string, image: string, item, Addon, resturantId: string, tableID: string, floor: string) {
        this.id = id;
        this.title = title;
        this.prices = prices;
        this.image = image;
        this.item = item;
        this.minprice = minprice;
        this.veg = veg;
        this.non_veg = non_veg;
        this.note = note;
        this.Addon = Addon;
        this.resturantId = resturantId;
        this.tableID = tableID;
        this.floor = floor;
    }
}
export class CartItem {
    id: number;
    title: string;
    prices: number;
    image: string;
    resturantId: string;
    quantity: number;
    veg: string;
    non_veg: string;
    packaging_cost;
    minprice: number;
    note: string;
    item: any;
    Addon = [];
    tableID: string;
    floor: string;


    constructor(item: MenuItem, quantity: number, items, Addon, packaging_cost, resturantId, tableID, floor) {
        this.id = item.id;
        this.title = item.title;
        this.prices = item.prices;
        this.image = item.image;
        this.minprice = item.minprice;
        this.note = item.note;
        this.quantity = quantity;
        this.item = items;
        this.veg = item.veg;
        this.non_veg = item.non_veg;
        this.Addon = Addon;
        this.packaging_cost = packaging_cost;
        this.resturantId = resturantId;
        this.tableID = tableID;
        this.floor = floor;
    }
}

@Injectable({
  providedIn: 'root'
})
export class CartService {
  list: Array<CartItem>;
  tableID: any;

  constructor(public storage: Storage) {
        this.storage.create();
        this.tableID = localStorage['tableid']
        this.list = []
        this.getvalue()
   }

   getvalue() {
        this.storage.get('cartItems').then((val) => {
            if (val == null || val == undefined) {
                this.list = []
                return this.list
            }
            else {
                return this.list = val
            }
        });
    }

    getAllCartItems() {
        return this.list;
    }
    getItemById(id: Number) {
        for (var i = 0; i < this.list.length; i++) {
            if (this.list[i].id == id) {
                this.changecart()
                return this.list[i];
            }
        }
    }

    package_cost() {
        let length = 0;
        this.list.forEach(element => {
            length += (element.packaging_cost * element.quantity)
        });
        return length;
    }

    addcartItem(item: MenuItem, quantity: number, items, Addon, tableID, floor) {
        // this.storage.get('cartItems').then((val) => {
        //     if (val == null || val == undefined) {
        //         this.list = []
        //     }
        //     else {
        //         this.list = val;
        //         this.list[Addon].quantity++
        //         this.storage.set('cartItems', this.list)
        //         // this.changecart()
        //         // this.list[Addon].quantity++
        //     }
        // });
        // this.getvalue()
        this.list[Addon].quantity++
        this.changecart()
        // return true;
    }

    addItem(item: MenuItem, quantity: number, items, Addon, resturantId, tableID, floor) {
        // this.getvalue()
        var isExists: boolean = false;
        var id = item.id;
        var packaging_cost = items.packaging_cost;
        for (var i = 0; i < this.list.length; i++) {
                if (this.list[i].id == id && Addon.length == 0 && this.list[i].tableID == tableID) {
                    this.list[i].quantity++
                    isExists = true;
                    this.changecart()
                    return true;
                }
                else if (this.list[i].id == id && Addon.length != 0 && this.list[i].tableID != tableID) {
                    isExists = false;
                    break;
                }
            else {
                isExists = false;
            }
        }
        if (!isExists) {
            this.list.push(new CartItem(item, quantity, items, Addon, packaging_cost, resturantId, tableID, floor));
            this.changecart()
            return true;
        }
    }

    update(item: MenuItem, quantity: number, items, Addon, resturantId, tableID, floor){
        
    }

    changecart() {
        this.storage.set('cartItems', this.list)
    }

    removeoneItemById(id, tableID, floor) {
        for (var i = 0; i < this.list.length; i++) {
            if (this.list[i].floor == floor) {
            if (this.list[i].tableID == tableID) {
                if (this.list[i].id == id) {
                    if (this.list[i].quantity != 0) {
                        this.list[i].quantity--
                        if (this.list[i].quantity == 0) {
                            this.list.splice(i, 1);
                            this.changecart()
                            break;
                        }
                        this.changecart()
                        break;
                    }
                    if (this.list[i].quantity == 0) {
                        this.list.splice(i, 1);
                        this.changecart()
                        break;
                    }
                    this.changecart()
                }
                }
            }
            this.changecart()
        }
    }

    removecartItemById(id, index, tableID, floor) {
        for (var i = 0; i < this.list.length; i++) {
            if (this.list[i].floor==floor) {
            if (this.list[i].tableID == tableID) {
                if (this.list[i].id == id) {
                    if (i== index) {
                    var j = i
                    this.list[j].quantity--
                    if (this.list[j].quantity == 0) {

                        this.list.splice(index, 1);
                        this.changecart()
                    }
                    this.changecart()
                }
                    
                }

            }
            }  
        }
    }
    emptyCart() {
        for (var i = 0; i < this.list.length; i++) {
            this.list.splice(i, 1);
            // this.changecart()
            i--;
        }
        this.storage.set('cartItems', this.list)
            // this.changecart()

    }

    quantityPlus(item) {
        item.quantity += 1;
    }

    quantityMinus(item) {
        item.quantity -= 1;
    }

    getCartLength() {
        let length = 0;
        this.list.forEach(element => {
            length += element.quantity;
        });
        return length;
    }

    get_restaurantId() {
        var res;
        for (var i = 0; i < this.list.length; i++) {
            res = this.list[i].resturantId
        }
        return res;
    }

    getGrandTotal(): number {
        var amount = 0;
        for (var i = 0; i < this.list.length; i++) {
            amount += (this.list[i].prices * this.list[i].quantity);
        }
        return amount;
    }
    remove_cart_item(id,index){
        // this.getvalue();
        let check_item=this.list.find(obj => obj.id == id);
        if(check_item){
            this.list.splice(index,1);
            this.changecart();
        }
    }
    update_cart_items(lists){
        this.list=lists;
        this.changecart();
    }

    TableCartItems(table) {
        // this.getvalue()
        var tableIDitems: any = [];
        for (var i = 0; i < this.list.length; i++) {
            if (this.list[i].tableID == table) {
                tableIDitems.push(this.list[i])
            }
        }
        // let t_array = tableIDitems.reverse();
        // return t_array;
        return tableIDitems;
    }

    getTableCartTotal(table): number {
        var amount = 0;
        for (var i = 0; i < this.list.length; i++) {
            // if (this.list[i].floor==floor) {
            if (this.list[i].tableID == table) {
                amount += (this.list[i].prices * this.list[i].quantity);
            }
            // }
        }
        return amount;
    }

    emptytableCart(table) {
        for (var i = 0; i < this.list.length; i++) {
            if (this.list[i].tableID == table) {
                this.list.splice(i, 1);
                i--;
            }
        } 
    }

    getTableCartLength(table) {
        // this.getvalue()
        var length = 0;
        for (var i = 0; i < this.list.length; i++) {
            // if (this.list[i].floor==floor) {
            if (this.list[i].tableID == table) {
                length += this.list[i].quantity;
            }
            // }
        }
        return length;

        // this.storage.get('cartItems').then((val) => {
        //     if (val == null || val == undefined) {
        //         this.list = []
        //     }
        //     else {
        //         this.list = val;
        //         let check = this.list.find(obj => obj.tableID == table)
        //         length += check.quantity;
        //         // this.changecart()
        //         // this.list[Addon].quantity++
        //     }
        // });
        // return length;
    }
}
